<template>
    <v-app-bar
    :clipped-left="$vuetify.breakpoint.lgAndUp"
    app
    color="blue darken-3"
    dark
    flat
    >
        <v-btn icon :to="`/${authenticated}`" v-if="user_type == 'customer'">
          <v-icon>mdi-apps</v-icon>
        </v-btn>
        <v-btn icon @click="hasHistory() ? $router.go(-1) : $router.push('/')" v-if="back && user_type == 'customer'">
          <v-icon>mdi-arrow-left</v-icon>
        </v-btn>
        <v-spacer v-if="user_type == 'customer'"></v-spacer>
        <v-img
            v-if="user_type == 'customer'"
            class="top-logo"
            max-width="150"
            src="https://api.mrpoolal.com/assets/theme/img/mrpool/logo.png"
            alt="Mr. Pool"
        ></v-img>
        <v-img
            v-else
            max-width="150"
            src="https://api.mrpoolal.com/assets/theme/img/mrpool/logo.png"
            alt="Mr. Pool"
        ></v-img>
        <v-spacer></v-spacer>
        <v-btn @click.prevent="installApp" v-if="install" tile color="#003e72" elevation="0" small>
            <v-icon>mdi-download</v-icon>
            Install
        </v-btn>
        <v-btn icon @click.prevent="signOut">
            <v-icon>mdi-logout</v-icon>
        </v-btn>
    </v-app-bar>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
    props: ['install'],
    data: () => ({
        back: false
    }),
    computed: {
        ...mapGetters({
            authenticated: 'auth/authenticated',
            user_type: 'data/user_type'
        }),
        menuToggle: {
            get() {
                return this.$store.state.menu.show_menu
            },
            set(newValue) {
                this.$store.commit('SET_MENU', newValue)
            }
        },
    },
    mounted() {
        if(this.$route.name != 'Jobs') {
            this.back = true
        }
    },
    watch:{
        $route (to){
            if(to.name == 'Jobs') {
                this.back = false
            } else {
                this.back = true
            }
        }
    },
    methods: {
        ...mapActions({
            signOutAction: 'auth/signOut'
        }),
        signOut() {
            this.signOutAction().then(() => {
                this.$router.replace({
                    name: 'Home'
                })
            })
        },
        installApp() {
            this.$emit('installApp')
        },
        hasHistory () { 
            return window.history.length > 2 
        },
    }
}
</script>

<style lang="sass" scoped>
.top-logo
    position: absolute
    left: 50%
    margin-left: -75px
</style>